module.exports = __webpack_public_path__ + "img/6.eac1a9c0.jpg";